export { default as styled } from './styled';
//# sourceMappingURL=index.js.map